.entry {
  &:hover {
    background-color: light-dark(
      var(--mantine-color-gray-0),
      var(--mantine-color-gray-8)
    );
  }
}
